import "./App.css";

import Landing from "./components/Landing";

function App(): JSX.Element {
  return <Landing />;
}

export default App;
